import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";
import { lenis } from "../global/scroll";

gsap.registerPlugin(ScrollTrigger, Draggable);

export default class ScrollbarHandler {
	constructor() {
		this.bar = null;
		this.thumb = null;
		this.trigger = null;
		this.draggable = null;
		this.scrollListener = null;
		this.barMouseEnter = null;
		this.barMouseLeave = null;
	}

	init() {
		if (ScrollTrigger.isTouch !== 1) {
			// Hide native scrollbar
			if (!document.getElementById("hide-scrollbar")) {
				const style = document.createElement("style");
				style.id = "hide-scrollbar";
				style.textContent = "body::-webkit-scrollbar{width:0}:root{scrollbar-width:none}";
				document.head.appendChild(style);
			}

			this.bar = document.createElement("div");
			this.bar.classList.add("fixed", "z-[100]", "top-0", "right-0", "w-2", "h-screen", "flex", "justify-end", "pointer-events-auto", "opacity-0");

			this.thumb = document.createElement("span");
			this.thumb.classList.add("w-1/2", "bg-lime", "transition-[width]");

			this.bar.appendChild(this.thumb);
			document
				.querySelector("main")
				.parentNode.insertBefore(
					this.bar,
					document.querySelector("main").nextSibling
				);

			this.initScrollbar();
		}
	}

	initScrollbar() {
		if (!this.bar) return;

		const bar = this.bar;
		const thumb = this.thumb;
		const scroller = document.body;
		const calc = document.body.offsetHeight / window.innerHeight;

		gsap.set(thumb, {
			height: 100 / calc + "%",
			yPercent: 0,
		});

		this.scrollListener = () => {
			const tl = gsap.timeline({ overwrite: true });
			tl.to(bar, { opacity: 1, overwrite: true, ease: "circ.out" });
			tl.to(bar, { opacity: 0, delay: 1, duration: 1, ease: "circ.out" });
		};
		lenis.on("scroll", this.scrollListener);

		this.barMouseEnter = () => {
			gsap.to(bar, { opacity: 1, overwrite: true, ease: "circ.out" });
			thumb.classList.add("!w-full");
		};
		this.barMouseLeave = () => {
			gsap.to(bar, { opacity: 0, delay: 1, duration: 1, ease: "circ.out" });
			thumb.classList.remove("!w-full");
		};
		bar.addEventListener("mouseenter", this.barMouseEnter);
		bar.addEventListener("mouseleave", this.barMouseLeave);

		let maxScroll = ScrollTrigger.maxScroll(scroller);
		let barLength = bar.offsetHeight - thumb.offsetHeight;
		const self = this;

		const updateHandler = () => {
			if (self.trigger) {
				gsap.set(thumb, {
					y: (barLength * self.trigger.scroll()) / maxScroll,
				});
			}
		};

		this.trigger = ScrollTrigger.create({
			scroller,
			start: 0,
			end: "max",
			onRefresh: () => {
				maxScroll = ScrollTrigger.maxScroll(scroller);
				barLength = bar.offsetHeight - thumb.offsetHeight;
				updateHandler();
			},
			onUpdate: updateHandler,
		});

		this.draggable = Draggable.create(thumb, {
			type: "y",
			bounds: bar,
			onDrag: function () {
				if (self.trigger) {
					self.trigger.scroll((this.y / barLength) * maxScroll);
				}
			},
		})[0];
	}

	destroy() {
		if (this.scrollListener) {
			lenis.off("scroll", this.scrollListener);
			this.scrollListener = null;
		}
		if (this.bar) {
			this.bar.removeEventListener("mouseenter", this.barMouseEnter);
			this.bar.removeEventListener("mouseleave", this.barMouseLeave);
		}
		if (this.draggable) {
			this.draggable.kill();
			this.draggable = null;
		}
		if (this.trigger) {
			this.trigger.kill();
			this.trigger = null;
		}
		if (this.thumb) {
			this.thumb.classList.remove("!w-full");
		}
	}
}
